export default import.meta.env.VITE_CI_COMMIT_REF_SLUG === 'master'
	? {
		PUBLIC_URL: 'https://inventory.estrack.com',
		API_URL: 'https://api.equipmentshare.com/',
		AUTH0_DOMAIN: 'auth.estrack.com',
		AUTH0_CLIENTID: 'tLxHmrNbqr6yBogi2MGQkWmQZrsI4BRn',
		AUTH0_AUDIENCE: 'https://api.equipmentshare.com',
		ENVIRONMENT: 'production',
		INTERCOM_APP_ID: 'cc3wvy5y',
		HEAP_APP_ID: '3705153768',
		LAUNCH_DARKLY_CLIENT_ID: '6227dd818f38cc14252b1dfd',
		DATADOG_APP_ID: '5859fcf3-c0ee-46a8-aacb-34a03e45423c',
		DATADOG_APP_TOKEN: 'pub17630c2ffacf841ce4e892b0782a9860',
		DATADOG_ENV: 'prod'
	}
	: {
		PUBLIC_URL: 'https://staging-inventory.estrack.com',
		API_URL: 'https://staging-api.equipmentshare.com/',
		AUTH0_DOMAIN: 'staging-auth.estrack.com',
		AUTH0_CLIENTID: 'hb4jFrtlH9eeFgSLeNGUI5897FHdRX9n',
		AUTH0_AUDIENCE: 'https://staging-api.equipmentshare.com',
		ENVIRONMENT: 'staging',
		INTERCOM_APP_ID: 'n3j6c2wc',
		HEAP_APP_ID: '3303332550',
		LAUNCH_DARKLY_CLIENT_ID: '6227dd818f38cc14252b1dfc',
		// Same RUM app as production, `env` tag differs
		DATADOG_APP_ID: '5859fcf3-c0ee-46a8-aacb-34a03e45423c',
		DATADOG_APP_TOKEN: 'pub17630c2ffacf841ce4e892b0782a9860',
		DATADOG_ENV: 'stage'
	}
